// extracted by mini-css-extract-plugin
module.exports = {"dialog":"UpdateDeliveryAddress_dialog__X_9zv","dialogSmall":"UpdateDeliveryAddress_dialogSmall__ekOfJ"};